/** Renders the shared compact control for switching color themes. */

import { Moon, Sun } from "lucide-react";
import { useTheme } from "../lib/theme";
import { Button } from "./ui/button";

/** Switches between the persisted dark and light themes. */
export function ThemeToggle() {
  const { theme, selectTheme } = useTheme();
  const nextTheme = theme === "dark" ? "light" : "dark";
  const label = `Switch to ${nextTheme} mode`;

  return (
    <Button
      type="button"
      size="icon"
      variant="outline"
      aria-label={label}
      title={label}
      onClick={() => selectTheme(nextTheme)}
    >
      {nextTheme === "light" ? (
        <Sun className="h-3.5 w-3.5" aria-hidden="true" />
      ) : (
        <Moon className="h-3.5 w-3.5" aria-hidden="true" />
      )}
    </Button>
  );
}
